import { render, staticRenderFns } from "./RegisterSimulasi.vue?vue&type=template&id=2d6d7792&scoped=true&"
import script from "./RegisterSimulasi.vue?vue&type=script&lang=js&"
export * from "./RegisterSimulasi.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSimulasi.vue?vue&type=style&index=0&id=2d6d7792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d7792",
  null
  
)

export default component.exports